import { useEffect, useState, useImperativeHandle, forwardRef, useRef } from 'react'
import {
  StepBackwardOutlined,
  CaretRightOutlined,
  PauseOutlined,
  StepForwardOutlined
} from '@ant-design/icons'
// import { message } from 'antd'
import { commonObj } from '@/common/common'

const Audio = forwardRef((props, ref) => {
  const baseUrl = commonObj.staticBaseUrl
  const [url, seturl] = useState('')
  const [playFlag, setPlayFlag] = useState(false)
  // const [messageApi, content] = message.useMessage()
  const [palyType, setPlayType] = useState(1) // 1列表循环（默认）2单曲循环 3随机播放
  const volume = useRef(1) // 当前音量
  const currentSong = useRef('')
  // const [isInit, setIsInit] = useState(true)
  const isInit = useRef(true) // 是否是初始化
  const oneFlag = useRef(false) // 是否只有一首歌曲

  const audioRef = useRef()
  useEffect(() => {
    const audioElement = audioRef.current
    if (audioElement) {
      // 此处添加监听播放与暂停主要是为了控制播放按钮，因为播放按钮可能是由于操作系统或者浏览器的音乐按钮触发的
      audioElement.addEventListener('play', playing)
      audioElement.addEventListener('pause', pause)
      audioElement.addEventListener('ended', playEnd)
      audioElement.addEventListener('timeupdate', handleTimeUpdate)
      // 清理函数确保移除事件监听器
      return () => {
        audioElement.removeEventListener('play', playing)
        audioElement.removeEventListener('pause', pause)
        audioElement.removeEventListener('ended', playEnd)
        audioElement.removeEventListener('timeupdate', handleTimeUpdate)
      }
    }
  }, [])
  useEffect(() => {
    // audioRef.current.volume = 1
    // window.addEventListener("keydown", initPlay)
    // return () => {
    //   window.removeEventListener("keydown", initPlay)
    // }
  }, [url])
  // 监听播放
  const playing = e => {
    setPlayFlag(true)
    // 通知父组件播放状态变化
    if (props.onPlayStatusChange) {
      props.onPlayStatusChange(true)
    }
  }
  // 监听暂停
  const pause = e => {
    setPlayFlag(false)
    // 通知父组件播放状态变化
    if (props.onPlayStatusChange) {
      props.onPlayStatusChange(false)
    }
  }
  // 监听结束
  const playEnd = () => {
    if (isInit.current) return
    changeSong(1)
  }
  // 监听播放时间更新
  const handleTimeUpdate = () => {
    if (audioRef.current && props.onTimeUpdate) {
      const currentTime = audioRef.current.currentTime
      props.onTimeUpdate(currentTime)
    }
  }
  // 初始化播放操作设置 (已移动到父组件处理)
  // const initPlay = e => {
  //   // 空格的keyCode是32，此处需要注意下如果以后改组件有输入框或文本框的情况下，按空格的时候得处理下
  //   if (e.keyCode === '32') {
  //     // var x = document.activeElement.tagName
  //     // if (x == "INPUT" || x == "TEXTAREA") {
  //     //   alert("暂无获得焦点的元素")
  //     // }
  //     if (url) {
  //       let flag = !playFlag
  //       setPlayStatus(flag)
  //     } else {
  //       // 如果没有正在播放的歌曲，则默认播放当前歌单的第一首
  //       props.setChangeSong()
  //     }
  //   }
  // }
  /**
   * @description 设置音乐地址
   * @param {String} val 音乐地址
   * @param {String | null} str 值为one或者为空，有值则表示只有一首歌，需要循环播放
   */
  const setMusicUrl = (val, str) => {
    isInit.current = false
    // console.log("音频组件", val)
    currentSong.current = val
    let url = baseUrl + val.sourceFile + '/' + val.songFileName
    seturl(url)
    setPlayFlag(true)
    if (str) {
      oneFlag.current = true
      audioRef.current.loop = true
    } else {
      oneFlag.current = false
      audioRef.current.loop = false
    }
  }
  // 设置播放状态
  const setPlayStatus = val => {
    if (!url) {
      props.handleKeydown({ key: ' ' })
      // messageApi.open({
      //   type: 'warning',
      //   content: '请选择歌曲'
      // })
      return
    }

    if (val) {
      // 播放时：先设置音量为0，开始播放，然后逐渐增大音量
      audioRef.current.volume = 0
      audioRef.current.play()
      setVolume('add', 0)
    } else {
      // 暂停时：先逐渐减小音量到0，然后暂停
      const currentVol = audioRef.current.volume
      volume.current = currentVol
      setVolume('cut', currentVol)
      // 延迟暂停，等音量渐变完成
      setTimeout(() => {
        audioRef.current.pause()
      }, Math.ceil(currentVol / 0.05) * 10) // 根据音量计算渐变时间
    }
    setPlayFlag(val)
  }
  // 设置audio的声音
  const setVolume = (type, val) => {
    if (type === 'add' && val < volume.current) {
      setTimeout(() => {
        const nextVal = Math.min(val + 0.05, volume.current) // 确保不超过之前保存的音量
        audioRef.current.volume = nextVal
        setVolume('add', nextVal)
      }, 10) // 增加延迟时间，让渐变更明显
    } else if (type === 'cut' && val > 0) {
      setTimeout(() => {
        const nextVal = Math.max(val - 0.05, 0) // 确保不小于0
        audioRef.current.volume = nextVal
        setVolume('cut', nextVal)
      }, 10)
    } else {
      // 到达边界值时直接设置
      audioRef.current.volume = val
    }
  }
  // 获取播放器当前的播放状态
  const getPlayStatus = () => {
    return playFlag
  }
  /**
   * @description 上一首与下一首
   * @param {Number} val 1下一首 -1上一首
   */
  const changeSong = val => {
    props.setChangeSong(currentSong.current, val)
  }
  // 播放方式切换
  const changePlayType = val => {
    setPlayType(val)
    if (oneFlag.current) {
      // 只有一首歌的话只能单曲循环
      audioRef.current.loop = true
    } else {
      switch (val) {
        case 2: // 单曲循环
          audioRef.current.loop = true
          break
        default: // 1列表循环(默认模式) 3随机播放
          audioRef.current.loop = false
          break
      }
    }
    props.setPlayMusicType(val)
  }
  // 导出父组件可调用的方法
  useImperativeHandle(ref, () => ({
    setMusicUrl,
    setPlayStatus,
    getPlayStatus
  }))

  return (
    <div className="audio_box">
      {/* {content} */}
      <div className="control_box">
        <StepBackwardOutlined title="上一首" className="icon1" onClick={() => changeSong(-1)} />
        {playFlag ? (
          <PauseOutlined title="暂停" className="icon2" onClick={() => setPlayStatus(false)} />
        ) : (
          <CaretRightOutlined title="播放" className="icon2" onClick={() => setPlayStatus(true)} />
        )}
        <StepForwardOutlined title="下一首" className="icon1" onClick={() => changeSong(1)} />
      </div>
      <audio ref={audioRef} autoPlay controls className="audio" src={url}></audio>
      {palyType === 1 && (
        <i className="iconfont right_icon" title="列表循环" onClick={() => changePlayType(2)}>
          &#xe605;
        </i>
      )}
      {palyType === 2 && (
        <i className="iconfont right_icon" title="单曲循环" onClick={() => changePlayType(3)}>
          &#xe604;
        </i>
      )}
      {palyType === 3 && (
        <i className="iconfont right_icon" title="随机播放" onClick={() => changePlayType(1)}>
          &#xe606;
        </i>
      )}
    </div>
  )
})

export default Audio
